import { c as _c } from "react/compiler-runtime";
import { CalendarIcon, Chip, HEX_ALPHA } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { PALETTE_CHANNELS, PALETTE_VARS, paletteAlpha } from "@styles/palette-vars";

/** Text shown on hover of a due date, so the urgency is not told by the color only */
export const DUE_DATE_URGENCY_TOOLTIPS = {
  none: "Due date",
  dueSoon: "Due within 7 days",
  overdue: "Overdue"
};
/** Style of the due date chip for each urgency, matching the due soon and overdue KPIs */
const DUE_DATE_CHIP_STYLES = {
  none: {
    backgroundColor: PALETTE_VARS.surfaces.tertiary,
    color: PALETTE_VARS.text.primary,
    borderColor: PALETTE_VARS.divider
  },
  dueSoon: {
    backgroundColor: paletteAlpha(PALETTE_CHANNELS.warning.main, HEX_ALPHA.alpha1F),
    color: PALETTE_VARS.text.primary,
    borderColor: PALETTE_VARS.warning.main
  },
  overdue: {
    backgroundColor: paletteAlpha(PALETTE_CHANNELS.error.main, HEX_ALPHA.alpha1F),
    color: PALETTE_VARS.error.main,
    borderColor: PALETTE_VARS.error.main
  }
};
/** Due date of a markup in the board, colored when it is due soon or overdue */
export function MarkupsBoardDueDateChip(t0) {
  const $ = _c(11);
  const {
    markup,
    urgency
  } = t0;
  const {
    formatDate
  } = useDateTime();
  if (!markup.dueDate) {
    return null;
  }
  const t1 = DUE_DATE_CHIP_STYLES[urgency];
  let t2;
  if ($[0] !== formatDate || $[1] !== markup.dueDate.value) {
    t2 = formatDate(markup.dueDate.value);
    $[0] = formatDate;
    $[1] = markup.dueDate.value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <var>{t2}</var>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = DUE_DATE_URGENCY_TOOLTIPS[urgency];
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CalendarIcon sx={{
      width: "0.875rem",
      height: "0.875rem"
    }} />;
    t6 = {
      flexShrink: 0
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t3 || $[9] !== t4) {
    t7 = <Chip {...t1} label={t3} size="small" textTransform="none" variant="outlined" tooltip={t4} icon={t5} sx={t6} />;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}